// -*- khung xem man hinh ao -*-
// Tach rieng vi ca man dang nhap lan man tai khoan deu dung.
//
// Hai cai bay da gap:
//   1. Nap iframe truoc khi websockify kip nghe cong -> nginx tra "502 Bad
//      Gateway", va trang loi do KHONG tu tai lai. Nen phai doi co vnc_san_sang.
//   2. Van co the hong vi ly do khac (mang, cho bi chiem) -> cho nguoi dung
//      bam tai lai thay vi ket cung.

import { useState } from "react";

export default function KhungVNC({
  url,
  sanSang,
  cao = 600,
}: {
  url: string;
  sanSang: boolean;
  cao?: number;
}) {
  const [lan, setLan] = useState(0);

  if (!sanSang) {
    return (
      <div
        style={{
          height: cao, marginTop: 12, display: "grid", placeItems: "center",
          border: "1px solid var(--border)", borderRadius: "var(--radius)",
          background: "var(--surface-2)", color: "var(--muted)", fontSize: 13,
        }}
      >
        Đang mở màn hình ảo trên máy chủ…
      </div>
    );
  }

  return (
    <div style={{ marginTop: 12 }}>
      {/* Man hinh ao la 1280x900; tren dien thoai no bi thu rat nho, tick
          captcha se kho. Noi truoc con hon de nguoi dung loay hoay. */}
      <div className="hint" style={{ marginTop: 0, marginBottom: 6 }}>
        Trên điện thoại khung này bị thu nhỏ, tick captcha sẽ khó. Xoay ngang máy,
        hoặc làm bước này trên máy tính rồi các lần sau đăng nhập bằng điện thoại
        vẫn bình thường.
      </div>
      <iframe
        key={lan}
        title="Cửa sổ Chrome trên máy chủ"
        src={url}
        style={{
          width: "100%", height: cao, background: "#1b1f28",
          border: "1px solid var(--border)", borderRadius: "var(--radius)",
          display: "block",
        }}
      />
      <div className="row" style={{ marginTop: 6 }}>
        <span className="hint" style={{ margin: 0 }}>
          Khung trống hoặc báo lỗi?
        </span>
        <button className="btn btn-sm" onClick={() => setLan((n) => n + 1)}>
          ↻ Tải lại khung
        </button>
      </div>
    </div>
  );
}
